/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthConsumeRouteImport } from './routes/auth.consume'
import { Route as AppPayoutRouteImport } from './routes/_app.payout'
import { Route as AppOnboardingRouteImport } from './routes/_app.onboarding'
import { Route as AppNotificationsRouteImport } from './routes/_app.notifications'
import { Route as AppDevelopersRouteImport } from './routes/_app.developers'
import { Route as AppBankAccountRouteImport } from './routes/_app.bank-account'
import { Route as AppSellersIndexRouteImport } from './routes/_app.sellers.index'
import { Route as AppInvoicesIndexRouteImport } from './routes/_app.invoices.index'
import { Route as AppDevelopersIndexRouteImport } from './routes/_app.developers.index'
import { Route as AppCustomersIndexRouteImport } from './routes/_app.customers.index'
import { Route as AppBuyersIndexRouteImport } from './routes/_app.buyers.index'
import { Route as AppSellersNewRouteImport } from './routes/_app.sellers.new'
import { Route as AppSellersIdRouteImport } from './routes/_app.sellers.$id'
import { Route as AppInvoicesNewRouteImport } from './routes/_app.invoices.new'
import { Route as AppInvoicesIdRouteImport } from './routes/_app.invoices.$id'
import { Route as AppDevelopersWebhooksRouteImport } from './routes/_app.developers.webhooks'
import { Route as AppDevelopersApiKeysRouteImport } from './routes/_app.developers.api-keys'
import { Route as AppCustomersNewRouteImport } from './routes/_app.customers.new'
import { Route as AppCustomersIdRouteImport } from './routes/_app.customers.$id'
import { Route as AppBuyersNewRouteImport } from './routes/_app.buyers.new'
import { Route as AppBuyersIdRouteImport } from './routes/_app.buyers.$id'
import { Route as AppAdminProductionAccessRouteImport } from './routes/_app.admin.production-access'
import { Route as AppInvoicesIdIndexRouteImport } from './routes/_app.invoices.$id.index'
import { Route as AppDevelopersWebhooksIndexRouteImport } from './routes/_app.developers.webhooks.index'
import { Route as AppInvoicesIdEditRouteImport } from './routes/_app.invoices.$id.edit'
import { Route as AppDevelopersWebhooksIdRouteImport } from './routes/_app.developers.webhooks.$id'
import { Route as AppCustomersPayerIdRouteImport } from './routes/_app.customers.payer.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthConsumeRoute = AuthConsumeRouteImport.update({
  id: '/auth/consume',
  path: '/auth/consume',
  getParentRoute: () => rootRouteImport,
} as any)
const AppPayoutRoute = AppPayoutRouteImport.update({
  id: '/payout',
  path: '/payout',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppDevelopersRoute = AppDevelopersRouteImport.update({
  id: '/developers',
  path: '/developers',
  getParentRoute: () => AppRoute,
} as any)
const AppBankAccountRoute = AppBankAccountRouteImport.update({
  id: '/bank-account',
  path: '/bank-account',
  getParentRoute: () => AppRoute,
} as any)
const AppSellersIndexRoute = AppSellersIndexRouteImport.update({
  id: '/sellers/',
  path: '/sellers/',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesIndexRoute = AppInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AppRoute,
} as any)
const AppDevelopersIndexRoute = AppDevelopersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDevelopersRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const AppBuyersIndexRoute = AppBuyersIndexRouteImport.update({
  id: '/buyers/',
  path: '/buyers/',
  getParentRoute: () => AppRoute,
} as any)
const AppSellersNewRoute = AppSellersNewRouteImport.update({
  id: '/sellers/new',
  path: '/sellers/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSellersIdRoute = AppSellersIdRouteImport.update({
  id: '/sellers/$id',
  path: '/sellers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesNewRoute = AppInvoicesNewRouteImport.update({
  id: '/invoices/new',
  path: '/invoices/new',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesIdRoute = AppInvoicesIdRouteImport.update({
  id: '/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDevelopersWebhooksRoute = AppDevelopersWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AppDevelopersRoute,
} as any)
const AppDevelopersApiKeysRoute = AppDevelopersApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppDevelopersRoute,
} as any)
const AppCustomersNewRoute = AppCustomersNewRouteImport.update({
  id: '/customers/new',
  path: '/customers/new',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIdRoute = AppCustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppBuyersNewRoute = AppBuyersNewRouteImport.update({
  id: '/buyers/new',
  path: '/buyers/new',
  getParentRoute: () => AppRoute,
} as any)
const AppBuyersIdRoute = AppBuyersIdRouteImport.update({
  id: '/buyers/$id',
  path: '/buyers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminProductionAccessRoute =
  AppAdminProductionAccessRouteImport.update({
    id: '/admin/production-access',
    path: '/admin/production-access',
    getParentRoute: () => AppRoute,
  } as any)
const AppInvoicesIdIndexRoute = AppInvoicesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInvoicesIdRoute,
} as any)
const AppDevelopersWebhooksIndexRoute =
  AppDevelopersWebhooksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDevelopersWebhooksRoute,
  } as any)
const AppInvoicesIdEditRoute = AppInvoicesIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AppInvoicesIdRoute,
} as any)
const AppDevelopersWebhooksIdRoute = AppDevelopersWebhooksIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppDevelopersWebhooksRoute,
} as any)
const AppCustomersPayerIdRoute = AppCustomersPayerIdRouteImport.update({
  id: '/customers/payer/$id',
  path: '/customers/payer/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/bank-account': typeof AppBankAccountRoute
  '/developers': typeof AppDevelopersRouteWithChildren
  '/notifications': typeof AppNotificationsRoute
  '/onboarding': typeof AppOnboardingRoute
  '/payout': typeof AppPayoutRoute
  '/auth/consume': typeof AuthConsumeRoute
  '/admin/production-access': typeof AppAdminProductionAccessRoute
  '/buyers/$id': typeof AppBuyersIdRoute
  '/buyers/new': typeof AppBuyersNewRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/customers/new': typeof AppCustomersNewRoute
  '/developers/api-keys': typeof AppDevelopersApiKeysRoute
  '/developers/webhooks': typeof AppDevelopersWebhooksRouteWithChildren
  '/invoices/$id': typeof AppInvoicesIdRouteWithChildren
  '/invoices/new': typeof AppInvoicesNewRoute
  '/sellers/$id': typeof AppSellersIdRoute
  '/sellers/new': typeof AppSellersNewRoute
  '/buyers/': typeof AppBuyersIndexRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/developers/': typeof AppDevelopersIndexRoute
  '/invoices/': typeof AppInvoicesIndexRoute
  '/sellers/': typeof AppSellersIndexRoute
  '/customers/payer/$id': typeof AppCustomersPayerIdRoute
  '/developers/webhooks/$id': typeof AppDevelopersWebhooksIdRoute
  '/invoices/$id/edit': typeof AppInvoicesIdEditRoute
  '/developers/webhooks/': typeof AppDevelopersWebhooksIndexRoute
  '/invoices/$id/': typeof AppInvoicesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/bank-account': typeof AppBankAccountRoute
  '/notifications': typeof AppNotificationsRoute
  '/onboarding': typeof AppOnboardingRoute
  '/payout': typeof AppPayoutRoute
  '/auth/consume': typeof AuthConsumeRoute
  '/admin/production-access': typeof AppAdminProductionAccessRoute
  '/buyers/$id': typeof AppBuyersIdRoute
  '/buyers/new': typeof AppBuyersNewRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/customers/new': typeof AppCustomersNewRoute
  '/developers/api-keys': typeof AppDevelopersApiKeysRoute
  '/invoices/new': typeof AppInvoicesNewRoute
  '/sellers/$id': typeof AppSellersIdRoute
  '/sellers/new': typeof AppSellersNewRoute
  '/buyers': typeof AppBuyersIndexRoute
  '/customers': typeof AppCustomersIndexRoute
  '/developers': typeof AppDevelopersIndexRoute
  '/invoices': typeof AppInvoicesIndexRoute
  '/sellers': typeof AppSellersIndexRoute
  '/customers/payer/$id': typeof AppCustomersPayerIdRoute
  '/developers/webhooks/$id': typeof AppDevelopersWebhooksIdRoute
  '/invoices/$id/edit': typeof AppInvoicesIdEditRoute
  '/developers/webhooks': typeof AppDevelopersWebhooksIndexRoute
  '/invoices/$id': typeof AppInvoicesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/bank-account': typeof AppBankAccountRoute
  '/_app/developers': typeof AppDevelopersRouteWithChildren
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/onboarding': typeof AppOnboardingRoute
  '/_app/payout': typeof AppPayoutRoute
  '/auth/consume': typeof AuthConsumeRoute
  '/_app/admin/production-access': typeof AppAdminProductionAccessRoute
  '/_app/buyers/$id': typeof AppBuyersIdRoute
  '/_app/buyers/new': typeof AppBuyersNewRoute
  '/_app/customers/$id': typeof AppCustomersIdRoute
  '/_app/customers/new': typeof AppCustomersNewRoute
  '/_app/developers/api-keys': typeof AppDevelopersApiKeysRoute
  '/_app/developers/webhooks': typeof AppDevelopersWebhooksRouteWithChildren
  '/_app/invoices/$id': typeof AppInvoicesIdRouteWithChildren
  '/_app/invoices/new': typeof AppInvoicesNewRoute
  '/_app/sellers/$id': typeof AppSellersIdRoute
  '/_app/sellers/new': typeof AppSellersNewRoute
  '/_app/buyers/': typeof AppBuyersIndexRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/developers/': typeof AppDevelopersIndexRoute
  '/_app/invoices/': typeof AppInvoicesIndexRoute
  '/_app/sellers/': typeof AppSellersIndexRoute
  '/_app/customers/payer/$id': typeof AppCustomersPayerIdRoute
  '/_app/developers/webhooks/$id': typeof AppDevelopersWebhooksIdRoute
  '/_app/invoices/$id/edit': typeof AppInvoicesIdEditRoute
  '/_app/developers/webhooks/': typeof AppDevelopersWebhooksIndexRoute
  '/_app/invoices/$id/': typeof AppInvoicesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/bank-account'
    | '/developers'
    | '/notifications'
    | '/onboarding'
    | '/payout'
    | '/auth/consume'
    | '/admin/production-access'
    | '/buyers/$id'
    | '/buyers/new'
    | '/customers/$id'
    | '/customers/new'
    | '/developers/api-keys'
    | '/developers/webhooks'
    | '/invoices/$id'
    | '/invoices/new'
    | '/sellers/$id'
    | '/sellers/new'
    | '/buyers/'
    | '/customers/'
    | '/developers/'
    | '/invoices/'
    | '/sellers/'
    | '/customers/payer/$id'
    | '/developers/webhooks/$id'
    | '/invoices/$id/edit'
    | '/developers/webhooks/'
    | '/invoices/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/bank-account'
    | '/notifications'
    | '/onboarding'
    | '/payout'
    | '/auth/consume'
    | '/admin/production-access'
    | '/buyers/$id'
    | '/buyers/new'
    | '/customers/$id'
    | '/customers/new'
    | '/developers/api-keys'
    | '/invoices/new'
    | '/sellers/$id'
    | '/sellers/new'
    | '/buyers'
    | '/customers'
    | '/developers'
    | '/invoices'
    | '/sellers'
    | '/customers/payer/$id'
    | '/developers/webhooks/$id'
    | '/invoices/$id/edit'
    | '/developers/webhooks'
    | '/invoices/$id'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/_app/bank-account'
    | '/_app/developers'
    | '/_app/notifications'
    | '/_app/onboarding'
    | '/_app/payout'
    | '/auth/consume'
    | '/_app/admin/production-access'
    | '/_app/buyers/$id'
    | '/_app/buyers/new'
    | '/_app/customers/$id'
    | '/_app/customers/new'
    | '/_app/developers/api-keys'
    | '/_app/developers/webhooks'
    | '/_app/invoices/$id'
    | '/_app/invoices/new'
    | '/_app/sellers/$id'
    | '/_app/sellers/new'
    | '/_app/buyers/'
    | '/_app/customers/'
    | '/_app/developers/'
    | '/_app/invoices/'
    | '/_app/sellers/'
    | '/_app/customers/payer/$id'
    | '/_app/developers/webhooks/$id'
    | '/_app/invoices/$id/edit'
    | '/_app/developers/webhooks/'
    | '/_app/invoices/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthConsumeRoute: typeof AuthConsumeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/consume': {
      id: '/auth/consume'
      path: '/auth/consume'
      fullPath: '/auth/consume'
      preLoaderRoute: typeof AuthConsumeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/payout': {
      id: '/_app/payout'
      path: '/payout'
      fullPath: '/payout'
      preLoaderRoute: typeof AppPayoutRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding': {
      id: '/_app/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/developers': {
      id: '/_app/developers'
      path: '/developers'
      fullPath: '/developers'
      preLoaderRoute: typeof AppDevelopersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bank-account': {
      id: '/_app/bank-account'
      path: '/bank-account'
      fullPath: '/bank-account'
      preLoaderRoute: typeof AppBankAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sellers/': {
      id: '/_app/sellers/'
      path: '/sellers'
      fullPath: '/sellers/'
      preLoaderRoute: typeof AppSellersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/': {
      id: '/_app/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AppInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/developers/': {
      id: '/_app/developers/'
      path: '/'
      fullPath: '/developers/'
      preLoaderRoute: typeof AppDevelopersIndexRouteImport
      parentRoute: typeof AppDevelopersRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/buyers/': {
      id: '/_app/buyers/'
      path: '/buyers'
      fullPath: '/buyers/'
      preLoaderRoute: typeof AppBuyersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sellers/new': {
      id: '/_app/sellers/new'
      path: '/sellers/new'
      fullPath: '/sellers/new'
      preLoaderRoute: typeof AppSellersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sellers/$id': {
      id: '/_app/sellers/$id'
      path: '/sellers/$id'
      fullPath: '/sellers/$id'
      preLoaderRoute: typeof AppSellersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/new': {
      id: '/_app/invoices/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AppInvoicesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/$id': {
      id: '/_app/invoices/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof AppInvoicesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/developers/webhooks': {
      id: '/_app/developers/webhooks'
      path: '/webhooks'
      fullPath: '/developers/webhooks'
      preLoaderRoute: typeof AppDevelopersWebhooksRouteImport
      parentRoute: typeof AppDevelopersRoute
    }
    '/_app/developers/api-keys': {
      id: '/_app/developers/api-keys'
      path: '/api-keys'
      fullPath: '/developers/api-keys'
      preLoaderRoute: typeof AppDevelopersApiKeysRouteImport
      parentRoute: typeof AppDevelopersRoute
    }
    '/_app/customers/new': {
      id: '/_app/customers/new'
      path: '/customers/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof AppCustomersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$id': {
      id: '/_app/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof AppCustomersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/buyers/new': {
      id: '/_app/buyers/new'
      path: '/buyers/new'
      fullPath: '/buyers/new'
      preLoaderRoute: typeof AppBuyersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/buyers/$id': {
      id: '/_app/buyers/$id'
      path: '/buyers/$id'
      fullPath: '/buyers/$id'
      preLoaderRoute: typeof AppBuyersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/production-access': {
      id: '/_app/admin/production-access'
      path: '/admin/production-access'
      fullPath: '/admin/production-access'
      preLoaderRoute: typeof AppAdminProductionAccessRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/$id/': {
      id: '/_app/invoices/$id/'
      path: '/'
      fullPath: '/invoices/$id/'
      preLoaderRoute: typeof AppInvoicesIdIndexRouteImport
      parentRoute: typeof AppInvoicesIdRoute
    }
    '/_app/developers/webhooks/': {
      id: '/_app/developers/webhooks/'
      path: '/'
      fullPath: '/developers/webhooks/'
      preLoaderRoute: typeof AppDevelopersWebhooksIndexRouteImport
      parentRoute: typeof AppDevelopersWebhooksRoute
    }
    '/_app/invoices/$id/edit': {
      id: '/_app/invoices/$id/edit'
      path: '/edit'
      fullPath: '/invoices/$id/edit'
      preLoaderRoute: typeof AppInvoicesIdEditRouteImport
      parentRoute: typeof AppInvoicesIdRoute
    }
    '/_app/developers/webhooks/$id': {
      id: '/_app/developers/webhooks/$id'
      path: '/$id'
      fullPath: '/developers/webhooks/$id'
      preLoaderRoute: typeof AppDevelopersWebhooksIdRouteImport
      parentRoute: typeof AppDevelopersWebhooksRoute
    }
    '/_app/customers/payer/$id': {
      id: '/_app/customers/payer/$id'
      path: '/customers/payer/$id'
      fullPath: '/customers/payer/$id'
      preLoaderRoute: typeof AppCustomersPayerIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppDevelopersWebhooksRouteChildren {
  AppDevelopersWebhooksIdRoute: typeof AppDevelopersWebhooksIdRoute
  AppDevelopersWebhooksIndexRoute: typeof AppDevelopersWebhooksIndexRoute
}

const AppDevelopersWebhooksRouteChildren: AppDevelopersWebhooksRouteChildren = {
  AppDevelopersWebhooksIdRoute: AppDevelopersWebhooksIdRoute,
  AppDevelopersWebhooksIndexRoute: AppDevelopersWebhooksIndexRoute,
}

const AppDevelopersWebhooksRouteWithChildren =
  AppDevelopersWebhooksRoute._addFileChildren(
    AppDevelopersWebhooksRouteChildren,
  )

interface AppDevelopersRouteChildren {
  AppDevelopersApiKeysRoute: typeof AppDevelopersApiKeysRoute
  AppDevelopersWebhooksRoute: typeof AppDevelopersWebhooksRouteWithChildren
  AppDevelopersIndexRoute: typeof AppDevelopersIndexRoute
}

const AppDevelopersRouteChildren: AppDevelopersRouteChildren = {
  AppDevelopersApiKeysRoute: AppDevelopersApiKeysRoute,
  AppDevelopersWebhooksRoute: AppDevelopersWebhooksRouteWithChildren,
  AppDevelopersIndexRoute: AppDevelopersIndexRoute,
}

const AppDevelopersRouteWithChildren = AppDevelopersRoute._addFileChildren(
  AppDevelopersRouteChildren,
)

interface AppInvoicesIdRouteChildren {
  AppInvoicesIdEditRoute: typeof AppInvoicesIdEditRoute
  AppInvoicesIdIndexRoute: typeof AppInvoicesIdIndexRoute
}

const AppInvoicesIdRouteChildren: AppInvoicesIdRouteChildren = {
  AppInvoicesIdEditRoute: AppInvoicesIdEditRoute,
  AppInvoicesIdIndexRoute: AppInvoicesIdIndexRoute,
}

const AppInvoicesIdRouteWithChildren = AppInvoicesIdRoute._addFileChildren(
  AppInvoicesIdRouteChildren,
)

interface AppRouteChildren {
  AppBankAccountRoute: typeof AppBankAccountRoute
  AppDevelopersRoute: typeof AppDevelopersRouteWithChildren
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppPayoutRoute: typeof AppPayoutRoute
  AppAdminProductionAccessRoute: typeof AppAdminProductionAccessRoute
  AppBuyersIdRoute: typeof AppBuyersIdRoute
  AppBuyersNewRoute: typeof AppBuyersNewRoute
  AppCustomersIdRoute: typeof AppCustomersIdRoute
  AppCustomersNewRoute: typeof AppCustomersNewRoute
  AppInvoicesIdRoute: typeof AppInvoicesIdRouteWithChildren
  AppInvoicesNewRoute: typeof AppInvoicesNewRoute
  AppSellersIdRoute: typeof AppSellersIdRoute
  AppSellersNewRoute: typeof AppSellersNewRoute
  AppBuyersIndexRoute: typeof AppBuyersIndexRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppInvoicesIndexRoute: typeof AppInvoicesIndexRoute
  AppSellersIndexRoute: typeof AppSellersIndexRoute
  AppCustomersPayerIdRoute: typeof AppCustomersPayerIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppBankAccountRoute: AppBankAccountRoute,
  AppDevelopersRoute: AppDevelopersRouteWithChildren,
  AppNotificationsRoute: AppNotificationsRoute,
  AppOnboardingRoute: AppOnboardingRoute,
  AppPayoutRoute: AppPayoutRoute,
  AppAdminProductionAccessRoute: AppAdminProductionAccessRoute,
  AppBuyersIdRoute: AppBuyersIdRoute,
  AppBuyersNewRoute: AppBuyersNewRoute,
  AppCustomersIdRoute: AppCustomersIdRoute,
  AppCustomersNewRoute: AppCustomersNewRoute,
  AppInvoicesIdRoute: AppInvoicesIdRouteWithChildren,
  AppInvoicesNewRoute: AppInvoicesNewRoute,
  AppSellersIdRoute: AppSellersIdRoute,
  AppSellersNewRoute: AppSellersNewRoute,
  AppBuyersIndexRoute: AppBuyersIndexRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppInvoicesIndexRoute: AppInvoicesIndexRoute,
  AppSellersIndexRoute: AppSellersIndexRoute,
  AppCustomersPayerIdRoute: AppCustomersPayerIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthConsumeRoute: AuthConsumeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
